import script from "./MessageStream.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageStream.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ConversationItem from "@/components/conversationItem/ConversationItem.vue";
import PendingMessage from "@/components/conversationItem/PendingMessage.vue";
script.components = Object.assign({}, { ConversationItem, PendingMessage }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConversationItem, PendingMessage }, script.__o.components);}